import React from "react";
import { Modal } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import TextFieldWithSuffix from "components/Ui/TextFieldWithSuffix";
import { getCampaignById } from "hooks/useCampaignData";
import { client } from "services/api";

import {
  Button,
  FormControl,
  TextField,
} from "@mui/material";
import { useStore } from "_Store";
import { updateInititalSolde } from "hooks/useCampaignData";
const initialValues = {
  //stocks: [],
};
const InitialSoldes= ({ visible, row, onSuccess, onCancel }) => {

  const {
    state:{
      activeCampaign,
      //activeFarm,
    },
    setUtils,setSelectedCampaignData
  } = useStore();
  //const { mutateAsync: updateCampaignStock } = updateInititalStock();
  React.useEffect(() => {
    return () => {
      formik.resetForm();
    }
  }, [row, visible]);

  const reloadCampaign = async () => {
    setUtils("loading", { spinning: true, primary: "" });
    const farmId = activeCampaign.farmId;
    let dt=new Date(activeCampaign.createdAt);
    const year=dt.getFullYear();
    const response = await client.get(
      `/campaign/getCampaign?farmId=${farmId}&year=${year}&campaignId=${activeCampaign.id}`
    );
    if (response.data.success) {
        setUtils("loading", { spinning: false, primary: "" });
        setSelectedCampaignData(response.data.data[0]);
    }
  }
  const close = () => {
    formik.resetForm();
    onCancel();
  };
  const validationSchema = yup.object().shape({
    initialCaisseSolde: yup
      .number()
      .typeError('Le solde de caisse doit être un nombre')
      .min(0, 'Le solde de caisse doit être supérieur ou égal à 0')
      .required('La valeur du solde de caisse est requise'),
  
    initialBanqueSolde: yup
      .number()
      .typeError('Le solde de banque doit être un nombre')
      .min(0, 'Le solde de banque doit être supérieur ou égal à 0')
      .required('La valeur du solde de banque est requise'),
  });  
  
  const formik = useFormik({
    initialValues: {
      initialCaisseSolde: 0,
      initialBanqueSolde: 0,
    },
    validationSchema,
    onSubmit: async (values) => {
      setUtils("loading", { spinning: true, primary: "" });
      try {
        await updateInititalSolde({
          initialCaisseSolde: values.initialCaisseSolde,
          initialBanqueSolde: values.initialBanqueSolde,
          campaignId: activeCampaign.id,
        }).then(async (res) => {
          if (res.success) {
            close();
            onSuccess("post");
            formik.resetForm();
            await reloadCampaign();
          }
        });
      } catch (error) {
        // Handle error
      } finally {
        setUtils("loading", { spinning: false, primary: "" });
      }
    },
  });
  

/* const handleChange = (field) => (value) => {
  formik.setFieldValue(field, value);
}; */

  return (
    <React.Fragment>
      <Modal
        visible={visible}
        open={visible}
        width={500}
        title={"Solde initial"}
        centered
        footer={null}
        onCancel={close}
      >
        <form onSubmit={formik.handleSubmit}>

<div>
  <h4 style={{ color:"orange" }}>Note : </h4>
  <p>Les solde initiaux de <strong>Caisse</strong> et de <strong>Banque</strong> définis ne pourront plus être modifier. Elles seront utilisés comme base pour les différentes opérations d'ENTREE et de SORTIE que vous initaliserez.</p>
</div>

<div className="mb-4">
  <label className="mb-2">Définir le solde initial de caisse</label>
  <FormControl fullWidth>
    <TextFieldWithSuffix
      name="initialCaisseSolde"
      inputLabel="Valeur du solde de caisse"
      value={formik.values.initialCaisseSolde}
      type="number"
      onChange={formik.handleChange}
      error={formik.touched.initialCaisseSolde && Boolean(formik.errors.initialCaisseSolde)}
      helperText={formik.touched.initialCaisseSolde && formik.errors.initialCaisseSolde}
      suffix="F CFA" 
    />
  </FormControl>
</div>

<div className="mb-4">
  <label className="mb-2">Définir le solde initial de banque</label>
  <FormControl fullWidth>
    <TextFieldWithSuffix
      name="initialBanqueSolde"
      inputLabel="Valeur du solde de banque"
      value={formik.values.initialBanqueSolde}
      onChange={formik.handleChange}
      type="number"
      error={formik.touched.initialBanqueSolde && Boolean(formik.errors.initialBanqueSolde)}
      helperText={formik.touched.initialBanqueSolde && formik.errors.initialBanqueSolde}
      suffix="F CFA"
    />
  </FormControl>
</div>
      

          <p className="mt-4">&nbsp;</p>
          <div className="flex justify-between">
            <Button
              size="large"
              variant="outlined"
              disableElevation
              color="secondary"
              onClick={close}
            >
              Annuler
            </Button>
            <Button
              size="large"
              variant="outlined"
              disableElevation
              color="success"
              type="submit"
            >
              Mettre à jour
            </Button>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default InitialSoldes;
